import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import SearchWorkplaceOld from './SearchWokrplaceOld';

loadDOMComponent({
	selector: 'react-search-workplace',
	callback: ({ container }: any) => {
		const linkSelect = container.getAttribute('linkSelect') || null;
		const gqlParams = JSON.parse(container.getAttribute('gqlParams') || '{}');

		// selectLink
		ReactDOM.render(
			<AppContextProvider>
				<SearchWorkplaceOld linkSelect={linkSelect} gqlParams={gqlParams} />
			</AppContextProvider>,
			container,
		);
	},
});
